import { useEffect, useState } from "react";

declare global {
    interface Navigator {
        standalone?: boolean;
    }
}

const checkPWA = () =>
    window.matchMedia("(display-mode: standalone)").matches ||
    (window.navigator as Navigator).standalone ||
    document.referrer.includes("android-app://");

export function usePWA(): boolean {
    const [isPWA, setIsPWA] = useState<boolean>(() => {
        if (typeof window === "undefined") return false;
        return checkPWA();
    });

    useEffect(() => {
        const mediaQuery = window.matchMedia("(display-mode: standalone)");
        const handleChange = (event: MediaQueryListEvent) =>
            setIsPWA(event.matches);

        setIsPWA(checkPWA());

        mediaQuery.addEventListener("change", handleChange);
        return () => mediaQuery.removeEventListener("change", handleChange);
    }, []);

    return isPWA;
}
